<template>
  <div class="header-box">
    <!-- 左边 -->
    <div class="left-box">
      <!-- logo -->
      <div class="logo">
        <img src="../img/home/logo.png" />
      </div>
      <router-link class="title pc" to="/">英雄游戏大数据中心</router-link>
      <router-link class="title mb" to="/">英雄大数据</router-link>
      <!-- 导航菜单栏 -->
      <div class="menu-box" @mouseleave="mouseLeave">
        <template v-for="(item,index) in menuList">
          <div class="menu-item" :key="index" :class="defaultCurrentMenuId == (index+1) ? 'menu-current' : ''" @click="handleJump(item,index)" >
            <div :id="'nav_'+index" class="nav" :class="currentMenu.menuName == item.menuName ? 'nav-current' : ''" @mouseenter="mouseEnter(item,'nav_'+index)">
              <span>{{item.menuName}}</span>
              <svg-icon v-if="item.menuShow" icon-class="arrows" class="icon" />
            </div>
          </div>
        </template>
        <!-- v-if="currentMenu.navList"  @mouseleave="mouseLeave"-->
        <!-- :class="{'f-nav-box' : currentMenu.id == 1, 's-nav-box': currentMenu.id == 2, 't-nav-box': currentMenu.id == 3, 'four-nav-box': currentMenu.id == 4, 'nav-current-box': currentMenu.isShow}" -->
        <div class="nav-box" :class="{'nav-current-box': currentMenu.isShow&&currentMenu.menuShow}" :style="'left:'+currentMenu.left+'px'">
          <div class="nav-item" v-for="(navItem, navIndex) in currentMenu.navList" :key="navIndex">
            <div class="nav-item-title" v-if="navItem.navType">{{navItem.navType}}</div>
            <div class="nav-item-content">
              <!--  v-if="navSon.link&&navSon.link!=''"  -->
              <a :href="navSon.link" target="_blank" class="link" v-for="(navSon, sonIndex) in navItem.list" :key="sonIndex">{{navSon.navName}} <img v-if="navSon.news" class="linkNew" src="../img/home/new.png" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 右边 -->
    <div class="right-box">

      <!-- 已登录 -->
      <template v-if="realName">
        <div class="menu-item">
          <div class="nav">
            <svg-icon class="user-icon" icon-class="nav-user" />
            <span class="text pc">欢迎，{{realName}}</span>
            <span class="text mb">{{realName}}</span>
            <svg-icon class="icon" icon-class="arrows" />
          </div>
          <div class="nav-box">
            <div class="nav-item" @click="logout">
              <div class="nav-item-content">
                <svg-icon class="user-icon" icon-class='nav-exit' />
                <span>退出登录</span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- 未登录 -->
      <template v-else>
        <!-- <div class="link" @click="login">注册账号</div> -->
        <div class="link-butn" @click="login">立即登录</div>
      </template>

      <div class="mb">
        <img class="caidan" src="../img/home/guanbicaidan.png" v-if="caidan" @click="caidan=false" />
        <img class="caidan" src="../img/home/caidan.png" v-else @click="caidan=true" />
      </div>
    </div>
    <el-dialog title="" :visible.sync="caidan" width="100%" top="70px" :show-close="false" :append-to-body="true" :modal="false">
      <el-scrollbar class="scrollMenuBox" style="width:100%" :style="{'height':'calc(100vh - 70px)'}">
        <el-collapse accordion>
          <el-collapse-item v-for="(menuItem,index) in menuList" :key="menuItem.menuName">
            <template slot="title">
              <span class="menu_mb_title" @click="handleJump(menuItem,index)">{{menuItem.menuName}}</span>
            </template>
            <div v-for="navItem in menuItem.navList" class="menu_mb_bg" :key="navItem.navType">
              <a :href="listItem.link" target="_blank" class="link menu_mb_link" v-for="listItem in navItem.list" :key="listItem.navName">
                <div>{{listItem.navName}}</div>
              </a>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Link from '../components/link'
export default {
  props: {
    currentMenuId: ''
  },
  data() {
    return {
      activeName: '1',
      caidan: false,
      menuList: [
        {
          id: 1,
          menuName: '数据中心',
          menuUrl: '/data',
          isShow: false,
          menuShow: true,
          navList: [
            {
              navType: '',//用户行为分析
              list: [
                {
                  navName: 'BDC 运营数据平台',
                  link: Link.Bdc
                },
                {
                  navName: 'GMS 客服查询平台',
                  link: Link.Gms
                },
                {
                  navName: 'DF   自助化分析平台',
                  link: Link.Df,
                  news: false
                },
                {
                  navName: 'NMS 舆情分析平台',
                  link: Link.Nms,
                  news: false
                }
              ]
            },
            // {
            //   navType: '广告营销分析',
            //   list: [
            //     {
            //       navName: 'Ad Tracking 广告监测平台',
            //       link: Link.Ad_Tracking
            //     },
            //     {
            //       navName: 'Ad Desk 广告投放平台',
            //       link: Link.Ad_Desk_New
            //     }
            //   ]

            // }
          ]
        },
        {
          id: 2,
          menuName: '推广中心',
          menuUrl: '/integration',
          isShow: false,
          menuShow: true,
          navList: [
            {
              navType: '',
              list: [
                {
                  navName: 'Ad Tracking 广告监测平台',
                  link: Link.Ad_Tracking
                },
                {
                  navName: 'Ad Desk 广告投放平台',
                  link: Link.Ad_Desk_New
                }
                // {
                //   navName: 'DS Platform 发行服务平台',
                //   link: Link.Ds_Platform
                // },
                // {
                //   navName: 'HFS 财务结算系统',
                //   link: Link.Hfs
                // },
                // {
                //   navName: 'USDK 融合SDK',
                //   link: Link.Usdk
                // },
                // {
                //   navName: 'CSDK 聊天SDK',
                //   link: Link.Csdk
                // }
              ]
            },
          ]
        },
        {
          id: 3,
          menuName: '资源中心',
          menuUrl: '/resource',
          isShow: false,
          menuShow: true,
          navList: [
            {
              navType: '',//视觉服务
              list: [
                {
                  navName: 'Arts Center 美术平台',
                  link: Link.Arts
                }
              ]
            },
           
          ]
        },
        {
          id: 4,
          menuName: '游戏业务中心',
          menuUrl: '/workbench',
          isShow: false,
          menuShow: true,
          navList: [
            {
              navType: '',
              list: [
                {
                  navName: 'OPEN 开发者平台',
                  link: Link.gmdc
                },
                {
                  navName: 'GMDP 游戏业务中台',
                  link: Link.gmdp
                },
                // {
                //   navName: 'OA自动化办公平台',
                //   link: Link.oa
                // },
                // {
                //   navName: 'HR管理服务平台',
                //   link: Link.ehr
                // },
                // {
                //   navName: '招聘管理系统',
                //   link: Link.zp
                // },
                // {
                //   navName: '财务管理系统(接入中)',
                //   link: Link.nc
                // },
              ]
            }
          ],
        },
        // {
        //   id: 5,
        //   menuName: '技术及支持',
        //   menuUrl: '/technology',
        //   isShow: false,
        //   menuShow: false,
        //   navList: [
        //     {
        //       navType: '',
        //       list: [
        //       ]
        //     }
        //   ],
        // },
        // {
        //   id: 6,
        //   menuName: '关于我们',
        //   menuUrl: '/about',
        //   isShow: false,
        //   menuShow: false,
        //   navList: [
        //     {
        //       navType: '',
        //       list: [
        //       ]
        //     }
        //   ],
        // }
      ],
      defaultCurrentMenuId: 0,
      currentMenu: {}
    }
  },
  computed: {
    ...mapGetters([
      'realName',
      'userInfo'
    ])
  },
  watch: {
    realName() {
      this.defaultCurrentMenuId = this.currentMenuId
      if (this.userInfo && this.userInfo.id) {
        this.menuList[3].menuShow = true
      }
    },
  },
  created() {
    this.defaultCurrentMenuId = this.currentMenuId
    if (this.userInfo && this.userInfo.id) {
      this.menuList[3].menuShow = true
    }
  },
  mounted() {
    window.onresize = () => {
      this.caidan = false
    };
  },
  methods: {
    // 鼠标移入
    mouseEnter(item,id) {
      var width = document.getElementById(id).offsetWidth
      // console.log('鼠标滑入===')
      this.currentMenu = JSON.parse(JSON.stringify(item))
      this.currentMenu.isShow = true
      this.currentMenu.left = document.getElementById(id).offsetLeft-(width/2)
    },

    // 鼠标移出
    mouseLeave() {
      // console.log('鼠标滑出===')
      this.currentMenu.isShow = false
      this.$nextTick(() => {
        this.currentMenu = {}
      })
    },

    // 导航跳转
    handleJump(item, index) {
      this.caidan = false;
      this.$router.push(item.menuUrl)
    },

    // 登录
    login() {
      // location.href = "https://auth.yingxiong.com/login?service=https%3A%2F%2Fbdc4.yingxiong.com%2Fcas%3Fclient_name%3Dbdc-client%26client_server_name%3DCasClient%26callbackUrl%3Dhttps%3A%2F%2Fhbdc.yingxiong.com%2F"
      location.href = "https://auth.yingxiong.com/login?service=https%3A%2F%2Fhbdc.yingxiong.com%2Fcas"
    },

    // 退出
    async logout() {
      await this.$store.dispatch('user/logout')
      location.href = "https://auth.yingxiong.com/logout?service="+window.location.protocol + "//" + window.location.host + "/logout"
    },
  }
}
</script>

<style lang="scss" scoped>
.header-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  min-width: 1000px;
  width: 100vw;
  height: 72px;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);

  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.mb {
  display: none;
}
.left-box,
.right-box,
.nav-box {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.left-box {
  justify-content: flex-start;
  .logo {
    flex-shrink: 0;
    width: 74px;
    height: 74px;
    background: #3a89ff;
    img {
      display: block;
      width: 34px;
      height: 40px;
      margin: 17px auto;
    }
  }
  .title {
    flex-shrink: 0;
    margin: 0 9px 0 19px;
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    line-height: 1;
  }
}

.menu-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  height: 74px;
  position: relative;
}

.menu-item {
  flex-shrink: 0;
  margin-left: 1.3vw;
  .nav {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    height: 74px;
    padding: 0 12px;
    cursor: pointer;
    position: relative;
    transition: all 0.3s;
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 3px;
      background: #3a89ff;
      transform: scale3d(0, 5, 1);
      transform-origin: 0% 50%;
      transition: transform 0.3s;
      // transition-timing-function: cubic-bezier(1, 0.68, 0.16, 0.9);
    }
  }
  span {
    font-size: 16px;
    color: #333333;
    transition: all 0.3s;
  }
  .icon {
    margin-left: 5px;
    width: 10px;
    height: 6px;
    color: #666666;
    transition: all 0.3s;
  }
}

.nav-box {
  opacity: 0;
  position: absolute;
  top: 70px;
  z-index: -1;
  width: auto;
  padding: 24px 20px 8px;
  background: #ffffff;
  box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  justify-content: flex-start;
  align-items: flex-start;
  transition: top 0.3s;
  .nav-item {
    margin: 0 20px;
    min-width: 190px;
    .nav-item-title {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 1;
      padding-bottom: 20px;
      margin-bottom: 16px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        border: 1px solid #e5e5e5;
      }
    }
    .nav-item-content {
      margin-bottom: 19px;
      .link {
        display: block;
        font-size: 14px;
        color: #333333;
        line-height: 1;
        margin-bottom: 16px;

        .linkNew {
          width: 34px;
          height: 14px;
          margin-left: 10px;
          vertical-align: middle;
          margin-top: -3px;
        }
      }
      .link:hover {
        color: #3a89ff;
      }
    }
  }
}
.f-nav-box {
  left: -70px;
}
.s-nav-box {
  left: 140px;
}
.t-nav-box {
  left: 240px;
}
.four-nav-box {
  left: 420px;
}

.menu-current {
  .nav {
    &::after {
      transform: scale3d(1, 1, 1);
    }
  }
  span {
    // font-weight: 600;
    color: #3a89ff;
  }
  .icon {
    color: #3a89ff;
  }
}

.nav-current {
  span {
    // font-weight: 600;
    color: #3a89ff;
  }
  .icon {
    color: #3a89ff;
    transform: rotate(180deg);
  }
}

.nav-current-box {
  opacity: 1;
  z-index: 9;
  top: 70px;
}

.right-box {
  flex-shrink: 0;
  justify-content: flex-end;
  margin: 0 2.8vw;
  .link {
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 600;
    color: #666666;
    cursor: pointer;
  }
  .link-butn {
    flex-shrink: 0;
    margin-left: 2.8vw;
    width: 88px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #3a89ff;
    border-radius: 4px;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
  }
  .user-icon {
    font-size: 24px;
    color: #666666;
  }
  .text {
    font-size: 14px;
    color: #333333;
    margin-left: 8px;
  }
  .menu-item {
    position: relative;
    .nav-box {
      top: 70px;
      left: 0;
      right: 0;
      z-index: 9;
      width: auto;
      padding: 6px 24px;
    }
    .nav-item {
      margin: 0;
      min-width: auto;
    }
    .nav-item-content {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      line-height: 40px;
      color: #666;
      cursor: pointer;
      span {
        font-size: 14px;
      }
      .user-icon {
        font-size: 20px;
        margin-right: 8px;
      }

      &:hover {
        .user-icon,
        span {
          color: #3a89ff;
        }
      }
    }
  }
  .menu-item:hover {
    .nav-box {
      opacity: 1;
    }
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 1240px) {
  .header-box {
    min-width: auto;
    width: 100%;
  }
  .pc {
    display: none;
  }
  .mb {
    display: inline-block;
  }
  .menu-box {
    display: none;
  }

  .caidan {
    width: 28px;
    height: 28px;
  }

  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  ::v-deep .el-collapse-item__arrow {
    transform: rotate(90deg);
  }

  ::v-deep .el-collapse-item__arrow.is-active {
    transform: rotate(-90deg);
  }

  ::v-deep .el-collapse-item__content {
    padding: 0;
  }

  .menu_mb_title {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
    padding-left: 30px;
  }
  .menu_mb_bg {
    background: #f9f9f9;
    padding-left: 50px;
  }
  .menu_mb_link {
    font-size: 15px;
    font-weight: 400;
    color: #333333;
    line-height: 45px;
  }

  .right-box .menu-item .nav-item {
    text-align: center;
    margin: 0 auto;
    min-width: 190px;
  }
}
</style>